module.exports = __webpack_public_path__ + "static/media/uploadAi.28640a8a.svg";